/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const updateTimesheetEntryPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const updateTimesheetEntry200Schema = z.any();

export const updateTimesheetEntryMutationRequestSchema = z.object({
  id: z.coerce.number().int().nullable().nullish(),
  customerId: z.coerce.number().int().nullable().nullish(),
  customerName: z.coerce.string(),
  description: z.coerce.string().nullable().nullish(),
  projectId: z.coerce.number().int().nullable().nullish(),
  projectName: z.coerce.string().nullable().nullish(),
  fromTime: z.string().datetime({ local: true }),
  toTime: z.string().datetime({ local: true }),
  effectiveHours: z.coerce.number(),
  km: z.coerce.number().nullable().nullish(),
  extraCosts: z.coerce.number().nullable().nullish(),
  costsDescription: z.coerce.string().nullable().nullish(),
  documents: z
    .array(
      z.object({
        id: z.coerce.number().int(),
        fileName: z.coerce.string(),
        description: z.coerce.string().nullable().nullish(),
        contentType: z.coerce.string(),
        fileExtension: z.coerce.string(),
        fileSizeBytes: z.coerce.number().int(),
        uploadedAt: z.string().datetime({ local: true }),
        updatedAt: z.string().datetime({ local: true }),
        uploadedByUserId: z.coerce.number().int().nullable().nullish(),
        linkedStatiniCount: z.coerce.number().int(),
      }),
    )
    .optional(),
  documentChanges: z
    .array(
      z.object({
        id: z.coerce.number().int().nullable().nullish(),
        fileName: z.coerce.string().nullable().nullish(),
        description: z.coerce.string().nullable().nullish(),
        updateDescription: z.boolean().optional(),
        contentType: z.coerce.string().nullable().nullish(),
        fileExtension: z.coerce.string().nullable().nullish(),
        fileSizeBytes: z.coerce.number().int().nullable().nullish(),
        contentBase64: z.coerce.string().nullable().nullish(),
        deleteScope: z.coerce.string().nullable().nullish(),
      }),
    )
    .optional(),
  mockUser: z.coerce.number().int().nullable().nullish(),
  isNewProject: z.boolean().nullable().nullish(),
  isNewCustomer: z.boolean().nullable().nullish(),
});

export const updateTimesheetEntryMutationResponseSchema = z.lazy(
  () => updateTimesheetEntry200Schema,
);
